"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shortenNumber = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var intlFormat = function intlFormat(number) {
  return new Intl.NumberFormat().format(Math.round(number * 10) / 10);
};
var shortenNumber = exports.shortenNumber = function shortenNumber(number) {
  if (number >= 1000000) {
    return intlFormat(number / 1000000) + "M";
  }
  if (number >= 1000) {
    return intlFormat(number / 1000) + "k";
  }
  return intlFormat(number);
};